module.exports = "img/flags/NE.29cd5f6.png";